// extracted by mini-css-extract-plugin
export var black = "_36-6";
export var brand = "_36-1";
export var ddefault = "_36-0";
export var error = "_36-3";
export var gray = "_36-2";
export var highContrast = "_36-8";
export var outline = "_36-7";
export var success = "_36-5";
export var warning = "_36-4";